// extracted by mini-css-extract-plugin
module.exports = {"container":"Tooltip_container__3TNMb","top":"Tooltip_top__2Nuvn","bottom":"Tooltip_bottom__3KVMB","content":"Tooltip_content__28JAx","large":"Tooltip_large__b7Jo2"};